import script from "./ProjectReport.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProjectReport.vue?vue&type=script&lang=ts&setup=true"

import "./ProjectReport.vue?vue&type=style&index=0&id=5811fb10&lang=scss&scoped=true"

import exportComponent from "E:\\svn\\xmTask(国振资产管理)1\\views\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5811fb10"]])

export default __exports__